import {ObdelavaDatuma} from '../SplosneGlobalneFunkcije/IzbiraMeseca.js'
import {PretvorbaEnot} from '../SplosneGlobalneFunkcije/PretvorbaEnotB'
import ClientAgent from '../../clientAgent'

export const PorabaTelefonija = {
  components: {
    ObdelavaDatuma,
    PretvorbaEnot
  },
  data () {
    return {
      clientAgent: null
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
  },
  methods: {
    GetPorabaInfo (prenosniParam) {
      let izbranMesec = new Date()
      if (typeof prenosniParam.izbranMesec !== 'undefined') {
        izbranMesec = new Date(prenosniParam.izbranMesec)
      }
      izbranMesec.setDate(1)
      let izbranoObdobje = ObdelavaDatuma.methods.DolociIzbranMesec(izbranMesec)
      let param = ['sap=' + prenosniParam.prenesenIzbranSap]
      param.push('telefonskaStevilka=' + prenosniParam.izbranaTelefonskaStevilka)
      param.push('datumOd=' + izbranoObdobje.trajanjeOd)
      param.push('datumDo=' + izbranoObdobje.trajanjeDo)
      param.push('izpisZakuplenihEnot=' + true)
      this.clientAgent.postWsRequest(
        this,
        'mercury/poraba',
        param,
        prenosniParam,
        'SetPorabaInfo',
        'ErrPorabaInfo')
    },
    SetPorabaInfo (podatki, prenosniParam) {
      let porabaInfo = []
      porabaInfo = podatki.destinations
      let returnData = {
        data: {
          prenosPodatkovNational: 0,
          maxPrenosPodatkovNational: null,
          prenosPodatkovNationalUnit: 'GB',
          prenosPodatkovTS: 0,
          maxPrenosPodatkovTS: null,
          maxPrenosPodatkovTSUnit: 'GB',
          mobilniTopPaket: false
        },
        message: {
          steviloPoslanihSmsov: 0,
          maxPoslanihSmsov: null,
          poslaniSmsUnit: null
        },
        skupnoSteviloKlicev: 0,
        kliciUnit: null,
        maxStKlicev: null,
        skupnaKolicinaZnesek: 0,
        skupnaKolicinaSekund: 0,
        msisdn: prenosniParam.izbranaTelefonskaStevilka
      }
      if (typeof prenosniParam.isMobilniTopPaket !== 'undefined') {
        returnData.mobilniTopPaket = prenosniParam.isMobilniTopPaket
      }
      if (typeof prenosniParam.numberType !== 'undefined') {
        returnData.type = prenosniParam.numberType
      }
      if (typeof porabaInfo !== 'undefined' && porabaInfo !== null) {
        if (typeof porabaInfo.message !== 'undefined' && porabaInfo.message !== null) {
          for (let i = 0; i < porabaInfo.message.length; i++) {
            returnData.message.steviloPoslanihSmsov += porabaInfo.message[i].actualQuantity
          }
        }
        if (typeof porabaInfo.voice !== 'undefined' && porabaInfo.voice !== null) {
          for (let i = 0; i < porabaInfo.voice.length; i++) {
            returnData.skupnoSteviloKlicev += porabaInfo.voice[i].transCount
          }
        }
        if (typeof porabaInfo.data !== 'undefined' && porabaInfo.data !== null) {
          for (let i = 0; i < porabaInfo.data.length; i++) {
            if (porabaInfo.data[i].billingCode.indexOf('PUDATAPRENOS-0') !== -1 ||
              porabaInfo.data[i].billingCode === 'PUDATAPRENOS-0') {
              returnData.data.prenosPodatkovNational += porabaInfo.data[i].actualQuantity
            }
            if (porabaInfo.data[i].billingCode.indexOf('PUDATAPRETELEKOM-0') !== -1 ||
              porabaInfo.data[i].billingCode === 'PUDATAPRETELEKOM-0') {
              returnData.data.prenosPodatkovTS += porabaInfo.data[i].actualQuantity
            }
          }
          let pNatty = PretvorbaEnot.methods.PretvoriKolicinoVPrijaznoObliko(returnData.data.prenosPodatkovNational)
          returnData.data.prenosPodatkovNational = pNatty
          if (pNatty.indexOf('GB') !== -1) {
            returnData.data.prenosPodatkovNational = returnData.data.prenosPodatkovNational.slice(0, -2)
          }
          let pNattyTS = PretvorbaEnot.methods.PretvoriKolicinoVPrijaznoObliko(returnData.data.prenosPodatkovTS)
          returnData.data.prenosPodatkovTS = pNattyTS
          if (pNattyTS.indexOf('GB') !== -1) {
            returnData.data.prenosPodatkovTS = returnData.data.prenosPodatkovTS.slice(0, -2)
          }
        }
      }
      if (typeof podatki.details !== 'undefined' && podatki.details !== null &&
        typeof podatki.details.voice !== 'undefined' &&
        podatki.details.voice !== null && podatki.details.voice.length > 0) {
        this.seznamKlicev = podatki.details.voice
        let stevecSkupnaVrednost = 0
        for (let i = 0; i < this.seznamKlicev.length; i++) {
          if (this.seznamKlicev[i].callDirection > 0) {
            returnData.skupnaKolicinaSekund += podatki.details.voice[i].actualDuration
            this.davek = (100 + podatki.details.voice[i].vat) / 100
            stevecSkupnaVrednost = stevecSkupnaVrednost + podatki.details.voice[i].amount
            returnData.skupnaKolicinaZnesek = (((stevecSkupnaVrednost * this.davek) /
              100).toFixed(4).replace('.', ',') + ' €')
          }
        }
      }
      let unitsInfo = podatki.units
      if (unitsInfo !== 'undefined' && unitsInfo !== null) {
        /* data limit */
        if (typeof unitsInfo.dataBalance !== 'undefined' && unitsInfo.dataBalance !== null) {
          for (let i = 0; i < unitsInfo.dataBalance.length; i++) {
            if (unitsInfo.dataBalance[i].network.indexOf('T2') !== -1) {
              returnData.data.prenosPodatkovNational = unitsInfo.dataBalance[i].used_unit
              returnData.data.maxPrenosPodatkovNational = unitsInfo.dataBalance[i].limit
              returnData.data.prenosPodatkovNationalUnit = unitsInfo.dataBalance[i].unit
              returnData.data.prenosPodatkovNationalNeomejeno =
                unitsInfo.dataBalance[i].limit === 0 && unitsInfo.dataBalance[i].rum === 'VOL'
              /* pretvorba iz evrocentov za mobilni top */
              if (returnData.mobilniTopPaket) {
                let kolicina = returnData.data.prenosPodatkovNational
                kolicina = PretvorbaEnot.methods.PretvoVEurIzEvroCentov(kolicina)
                returnData.data.prenosPodatkovNational = kolicina
                kolicina = returnData.data.maxPrenosPodatkovNational
                kolicina = PretvorbaEnot.methods.PretvoVEurIzEvroCentov(kolicina)
                returnData.data.maxPrenosPodatkovNational = kolicina
              }
            }
            if (unitsInfo.dataBalance[i].network.indexOf('NR') !== -1) {
              returnData.data.prenosPodatkovTS = unitsInfo.dataBalance[i].used_unit
              returnData.data.maxPrenosPodatkovTS = unitsInfo.dataBalance[i].limit
              returnData.data.maxPrenosPodatkovTSUnit = unitsInfo.dataBalance[i].unit
              /* pretvorba iz evrocentov za mobilni top */
              if (returnData.mobilniTopPaket) {
                let kolicina = returnData.data.prenosPodatkovTS
                kolicina = PretvorbaEnot.methods.PretvoVEurIzEvroCentov(kolicina)
                returnData.data.prenosPodatkovTS = kolicina
                kolicina = returnData.data.maxPrenosPodatkovTS
                kolicina = PretvorbaEnot.methods.PretvoVEurIzEvroCentov(kolicina)
                returnData.data.maxPrenosPodatkovTS = kolicina
              }
            }
          }
        }
        if (typeof unitsInfo.information !== 'undefined' && unitsInfo.information !== null) {
          for (let i = 0; i < unitsInfo.information.length; i++) {
            /* sporočila */
            if (unitsInfo.information[i].targeted_rum === 'EVT') {
              returnData.message.maxPoslanihSmsov = unitsInfo.information[i].limit
              returnData.message.steviloPoslanihSmsov = unitsInfo.information[i].used_unit
              /* pretvorba iz evrocentov za mobilni top */
              if (returnData.mobilniTopPaket) {
                let kolicina = returnData.message.steviloPoslanihSmsov
                kolicina = PretvorbaEnot.methods.PretvoVEurIzEvroCentov(kolicina)
                returnData.message.steviloPoslanihSmsov = kolicina
                kolicina = returnData.message.maxPoslanihSmsov
                kolicina = PretvorbaEnot.methods.PretvoVEurIzEvroCentov(kolicina)
                returnData.message.maxPoslanihSmsov = kolicina
                returnData.message.poslaniSmsUnit = unitsInfo.information[i].rum
              }
            }
            /* klici */
            if (unitsInfo.information[i].targeted_rum === 'DUR') {
              returnData.skupnoSteviloKlicev = unitsInfo.information[i].used_unit
              returnData.maxStKlicev = unitsInfo.information[i].limit
              /* pretvorba iz evrocentov za mobilni top */
              if (returnData.mobilniTopPaket) {
                let kolicina = returnData.skupnoSteviloKlicev
                kolicina = PretvorbaEnot.methods.PretvoVEurIzEvroCentov(kolicina)
                returnData.skupnoSteviloKlicev = kolicina
                kolicina = returnData.maxStKlicev
                kolicina = PretvorbaEnot.methods.PretvoVEurIzEvroCentov(kolicina)
                returnData.maxStKlicev = kolicina
                returnData.kliciUnit = unitsInfo.information[i].rum
              }
            }
          }
        }
      }
      if (typeof prenosniParam.callBackFunction === 'function') {
        prenosniParam.callBackFunction(returnData)
      }
    },
    ErrPorabaInfo (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/PorabaTelefonija/PorabaTelefonija.js